var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-item-content"},[_c('div',{staticClass:"text-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"text-content"},[_vm._v(_vm._s(_vm.dateFormat(_vm.datamodel.value, 'yyyy-MM-dd hh:mm:ss')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }